import React from "react";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

interface AavoWizardStepContextValue {
	/** Call this whenever the step's form validation state changes. */
	onValidationChange: (isValid: boolean) => void;
	/** Call this when the step's form content is edited. Used for dirty-state tracking in dialogs. */
	onFormEdited?: () => void;
}

export const AavoWizardStepContext = React.createContext<AavoWizardStepContextValue | undefined>(
	undefined,
);

/** Hook for step content to report validation state to the wizard. */
export const useAavoWizardValidation = (): AavoWizardStepContextValue =>
	useContextOrThrow(AavoWizardStepContext);
